<!--
 * @Description: 消息列表卡片
 * @Author: Xiaochun liu
 * @Date: 2024-04-09 14:08:28
 * @LastEditors: Xiaochun liu
 * @LastEditTime: 2024-12-09 11:38:22
-->
<script setup lang="ts">
import { useMessage } from 'naive-ui'
import { reviewJoinCompanyApply, reviewJoinCompanyProductApply } from '@/api/message-notify'
import ApplyForEnterpriseDialog from './ApplyForEnterpriseDialog.vue'
import ApplyForProductDialog from './ApplyForProductDialog.vue'
import { useUserStore } from '@/store'
import { openWindowWithWorkspace } from '@/utils/tool'

const props = defineProps({
  messageData: {
    type: Object,
    default: () => { },
  },
  isSmall: {
    type: Boolean,
    default: false,
  },
})

const emits = defineEmits(['updateHandle'])

const message = useMessage()

const userStore = useUserStore()
const userInfo = computed(() => userStore.userInfo)
const isUser = computed(() => userInfo.value.id === props.messageData.userId)

const enterpriseVisible = ref(false)
const productVisible = ref(false)
const limitVisible = ref(false)
// 通过
function passHandle(val) {
  // feedConfigId 类型id:55:申请加入企业产品、56:申请加入产品、57:申请加入企业
  if (val.feedConfigId === 57) {
    enterpriseVisible.value = true
  }
  if (val.feedConfigId === 55 || val.feedConfigId === 56) {
    productVisible.value = true
  }
}
function updateHandle() {
  emits('updateHandle')
}
// 拒绝
function rejectHandle(val) {
  // feedConfigId 类型id:55:申请加入企业产品、56:申请加入产品、57:申请加入企业
  if (val.feedConfigId === 57) {
    reviewJoinCompanyApply({
      applyId: val.applyId,
      code: 2,
      enterpriseId: val.enterpriseId,
    }).then((res) => {
      window.$message?.warning(`你拒绝了${val.nickName}的加入申请`)
      updateHandle()
    }).catch((error) => {
      if (error.code === 90003) {
        limitVisible.value = true
      } else {
        message.error(error.resultMsg)
      }
    })
  }
  if (val.feedConfigId === 55 || val.feedConfigId === 56) {
    reviewJoinCompanyProductApply({
      applyId: val.applyId,
      code: 2,
      enterpriseId: val.enterpriseId,
      archiveId: val.archiveId,
    }).then((res) => {
      window.$message?.warning(`你拒绝了${val.nickName}的加入申请`)
      updateHandle()
    }).catch((error) => {
      message.error(error.resultMsg)
    })
  }
}

// 进入空间
function toSpace(val) {
  window.open(`/workbench?workspace=${val.enterpriseId}`)
}

// 产品详情
function toDetail(val) {
  openWindowWithWorkspace(`/productDetailMain/productDetail?archiveId=${val.archiveId}&enterpriseId=${val.enterpriseId}`)
}
</script>

<template>
  <div class="notify-card-wrap" :class="{ 'is-small': isSmall }">
    <!-- <div v-if="messageData.unread === 0" class="dot" /> -->
    <div class="time">
      {{ messageData.createTime }}
    </div>
    <div class="content">
      {{ messageData.content }}
    </div>
    <!-- 根据状态判断 -->
    <div class="opera-wrap">
      <div v-if="messageData.status === 0 && !isUser" class="opera-btn flex items-center">
        <NButton class="refuse-btn" :data-ph-capture-attribute-page-actions="$getPosthogPath(['拒绝'])"
          @click="rejectHandle(messageData)">
          拒绝
        </NButton>
        <button class="pass-btn button-gradient" :data-ph-capture-attribute-page-actions="$getPosthogPath(['通过'])"
          @click="passHandle(messageData)">
          通过
        </button>
      </div>
      <div v-if="messageData.status === 1 && !isUser" class="approved flex items-center">
        <div class="success-icon" />
        已审核通过
      </div>
      <div v-if="messageData.status === 2 && !isUser" class="refused flex items-center">
        <div class="error-icon" />
        已拒绝
      </div>
      <button v-if="messageData.status === 1 && isUser && !messageData.archiveId" class="space-btn button-gradient"
        :data-ph-capture-attribute-page-actions="$getPosthogPath(['进入空间', messageData.enterpriseId])"
        @click="toSpace(messageData)">
        进入空间
      </button>
      <button v-if="messageData.status === 1 && isUser && messageData.archiveId" class="detail-btn button-gradient"
        :data-ph-capture-attribute-page-actions="$getPosthogPath(['产品详情', messageData.archiveId])"
        @click="toDetail(messageData)">
        提案详情
      </button>
    </div>
    <!-- 加入企业申请审批 -->
    <ApplyForEnterpriseDialog v-model="enterpriseVisible" :data="messageData" @updateHandle="updateHandle" />
    <!-- 加入产品申请审批 -->
    <ApplyForProductDialog v-model="productVisible" :data="messageData" @updateHandle="updateHandle" />

    <!-- 达到上限弹窗 -->
    <LimitDialog v-model="limitVisible" dialog-title="成员申请审核">
      <template #default>
        <div class="tip text-[14px] text-[#F53F3F]">
          通过失败，空间成员数量已达上限
        </div>
        <div class="tip text-[#425466]">
          您可联系下方客服扩充空间成员数量
        </div>
      </template>
    </LimitDialog>
  </div>
</template>

<style lang="scss" scoped>
.notify-card-wrap {
  position: relative;
  width: 100%;
  padding: 20px 24px;
  margin-bottom: 16px;
  background: #FFFFFF;
  border-radius: 8px;


  &.is-small {
    padding: 12px;

    .content {
      font-size: 12px;
      line-height: 18px;
    }
  }

  .dot {
    position: absolute;
    top: 8px;
    right: 8px;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: #FF4080;
  }

  .time {
    margin-bottom: 4px;
    font-size: 12px;
    color: #8FA1B2;
    line-height: 18px;
  }

  .content {
    font-weight: 500;
    font-size: 14px;
    color: #242F57;
    line-height: 24px;
  }

  .opera-wrap {

    .opera-btn,
    .space-btn,
    .detail-btn {
      margin-top: 8px;
    }

    .refuse-btn,
    .pass-btn,
    .space-btn,
    .detail-btn {
      padding: 3px 12px;
      font-size: 12px;
    }

    .refuse-btn {
      margin-right: 8px;
      height: 28px;
    }

    .approved,
    .refused {
      margin-top: 8px;
    }

    .approved {
      width: fit-content;
      padding: 6px 8px;
      background: #EDFBF6;
      border-radius: 4px;
      font-size: 12px;
      color: #242F57;
      line-height: 17px;

      .success-icon {
        width: 12px;
        height: 12px;
        margin-right: 2px;
        background: url('./icons/success-icon.png') no-repeat;
        background-size: contain;
      }
    }

    .refused {
      width: fit-content;
      padding: 6px 8px;
      background: #FEECEC;
      border-radius: 4px;
      font-size: 12px;
      color: #425466;
      line-height: 17px;

      .error-icon {
        width: 12px;
        height: 12px;
        margin-right: 2px;
        background: url('./icons/error-icon.png') no-repeat;
        background-size: contain;
      }
    }
  }
}
</style>
